var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconTrashFilled(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "20px",
    height: "22px",
    viewBox: "0 0 20 22",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Icon/Trash/Filled") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "PA-Question-Bank-",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Platform-Admin-/-Test-Builder-/-Matrix-Multiple-Question-(simple)-/-Uploaded-files",
    transform: "translate(-1358.000000, -888.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Question-Content",
    transform: "translate(96.000000, 695.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "PDF",
    transform: "translate(24.000000, 180.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon/Trash/Filled",
    transform: "translate(1236.000000, 12.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Base",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.8214286,2.37501409 L15.7321428,2.37501409 L15.3334821,1.57149901 L15.3334822,1.57149906 C15.1612281,1.22110762 14.8080176,0.999735776 14.4216518,1.0000075 L9.57410714,1.0000075 L9.57410718,1.0000075 C9.1884691,0.998513084 8.83592325,1.22050133 8.6665179,1.57149906 L8.26785718,2.37501414 L3.17857146,2.37501414 L3.17857143,2.37501414 C2.80380661,2.37501416 2.5,2.682818 2.5,3.06251368 C2.5,3.06251368 2.5,3.06251368 2.5,3.06251368 L2.5,4.43751275 L2.5,4.43751265 C2.5,4.81720833 2.80380661,5.12501218 3.17857143,5.12501218 L20.8214286,5.12501218 L20.8214286,5.12501218 C21.1961934,5.12501218 21.5,4.81720833 21.5,4.43751265 L21.5,3.06251357 L21.5,3.06251357 C21.5,2.68281789 21.1961934,2.37501404 20.8214286,2.37501404 L20.8214286,2.37501409 Z M4.75624997,21.0664077 L4.75624996,21.0664076 C4.82342429,22.1532111 5.71293389,23 6.78772318,23 L17.2122768,23 L17.2122769,23 C18.2870661,23 19.1765757,22.1532111 19.2437501,21.0664076 L20.1428572,6.50001115 L3.85714291,6.50001115 L4.75624997,21.0664077 Z",
    id: "Icon",
    fill: "#586179"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconTrashFilled);
export default __webpack_public_path__ + "static/media/icon-trash-filled.89bee4bd.svg";
export { ForwardRef as ReactComponent };